<script setup>
import { reactive } from 'vue';

const isOpen = reactive({});
// const isOpen2 = ref(false);
// const isOpen3 = ref(false);
</script>

<template>
    <div id="nav-bar">
        <b-img 
            :src="require('@/assets/logo.png')"
            fluid
            class="mt-3 mb-4"
        />
        <nav 
            v-for="item in menu"
            :key="item.uuid"
            class="nav-bar-menu d-flex flex-column"
        >
            <router-link
                v-if="!item.submodulos && ('componentes' in item)"
                :to="item.componentes[0].path"
                active-class="active"
                class="nav-bar-menu__item"
            >
                {{ item.modulo }}
            </router-link>
            <div
                v-else
                class="nav-bar-menu__item d-flex align-items-center justify-content-between click"
                @click="isOpen[item.uuid] = !isOpen[item.uuid]"
            >
                <span>{{ item.modulo }}</span>
                <span :class="`material-symbols-outlined ${(isOpen[item.uuid]) ? 'down' : ''}`">chevron_forward</span>
            </div>
            <b-collapse
                v-if="item.submodulos" 
                v-model="isOpen[item.uuid]"
                :visible="isSubModuloActive(item)"
            >
                <nav class="nav-bar-menu d-flex flex-column">
                    <router-link
                        v-for="sub in item.submodulos"
                        :key="sub.uuid" 
                        :to="('componentes' in sub) ? sub.componentes[0].path : ''"
                        class="nav-bar-menu__item sub"
                        active-class="active"
                    >
                        {{ sub.modulo }}
                    </router-link>
                </nav>
            </b-collapse>
        </nav>
    </div>
</template>

<script>
import { BImg, BCollapse } from 'bootstrap-vue-3';

export default {
    name: 'SideBarNav',
    components: {
        BImg,
        BCollapse,
    },
    data() {
        return {
            menu: sessionStorage.getItem('modulos') ? JSON.parse(sessionStorage.getItem('modulos')) : [],
        }
    },
    methods: {
        isSubModuloActive(item) {
            if (!item.submodulos) return false;
            return item.submodulos.some(sub => {
                const path = ('componentes' in sub) ? sub.componentes[0].path : '';
                return this.$route.path.startsWith(path);
            });
        }
    }
}
</script>

<style scoped>
.nav-bar-menu__item {
    text-align: start;
    padding: 1rem;
    padding-left: 2rem;
    text-decoration: none;
    color: #404040;
    font-weight: bold;
    width: 90%;
    margin: 0 auto;
    border-radius: 8px;
    transition: .1s ease-in-out;
}

.sub {
    padding-left: 3rem !important;
}

.sub-2 {
    padding-left: 4rem !important;
}

.down {
    transform: rotate(90deg)
}

.nav-bar-menu__item:hover {
    background-color: #ecebeb;
}

.active {
    background-color: #FF0003;
    color: white !important;
}

.card-content {
    height: 4rem !important;
    margin-top: 1rem;
    margin-bottom: 3rem;
}

</style>